export function addRule(styleSheet: LinkStyle, _name: string, rule: string) {
  const sheet = styleSheet.sheet as CSSStyleSheet;
  const rules = Array.from(sheet.cssRules);
  const index = rules.findIndex(n => n.cssText === rule);

  if (index !== -1) {
    sheet.deleteRule(index);
  }

  sheet.insertRule(rule, sheet.cssRules.length);
}
